import { createElement } from 'react';
import { node, bool, string } from 'prop-types';
import { withTheme } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Set/styled.js';
import '../Set/index.js';
import _FieldSet from './styled.js';

var FieldSet = function FieldSet(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "theme"]);

  var spacing = props.spacing || _get(theme, 'fannypack.FieldSet.spacing');

  return createElement(_FieldSet, _extends({
    isVertical: !props.isHorizontal
  }, props, {
    spacing: spacing
  }), children);
};
var fieldSetPropTypes = {
  children: node.isRequired,
  isHorizontal: bool,
  spacing: string
};
FieldSet.propTypes = fieldSetPropTypes;
var fieldSetDefaultProps = {
  isHorizontal: false,
  spacing: undefined
};
FieldSet.defaultProps = fieldSetDefaultProps; // @ts-ignore

var C = withTheme(FieldSet);

export default C;
export { C as FieldSet, fieldSetDefaultProps, fieldSetPropTypes };
